import { useEffect } from "react";

const useEffectAsync = <T>(effect: () => void | Promise<void>, deps?: T[]) => {
  useEffect(() => {
    let isSubscribed = true;
    if (isSubscribed) {
      void effect();
    }
    return () => {
      isSubscribed = false;
    };
  }, deps);
};

export default useEffectAsync;
